import { apiRequest } from "../../api/apiRequest";
import { APPLICATION_ENDPOINT } from "../../api/urls";

export const fetchApplications = (id) => {
    return apiRequest("GET", `${APPLICATION_ENDPOINT}get/all/?workspace=${id}`);
};
